<template>
<ValidationObserver ref="observer">
  <form ref="add_nota_jasa_bkl_form" @submit.prevent="addNotaJasaBkl">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Nota Jasa Bkl
        </h4> 
      </md-card-header> -->
      <md-card-content>
        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
           (Read) No. Nota Jasa Bkl
          </label>
          <div class="md-layout-item">
            <validation-provider rules="jasano" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input readonly v-model="nota_jasa_bkl_no" />
              <validation-error :errors="apiValidationErrors.nota_jasa_bkl_no" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div> -->
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            (Read) PKB No
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="jasano" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">(Read) PKB No</label>
                <md-input readonly type="hidden" v-model="nota_jasa_bkl_pkb_id" />
                <md-input readonly v-model="nota_jasa_bkl_pkb_no" />
                <validation-error :errors="apiValidationErrors.nota_jasa_bkl_pkb_id" />
              </md-field>
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            (Read) Nota Jasa Bkl Date
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="datetime" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Nota Jasa Bkl Date</label>
              <md-input type="date" v-model="nota_jasa_bkl_datetime" disabled/>
              <validation-error :errors="apiValidationErrors.nota_jasa_bkl_datetime" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Service
          </label> -->
          <div class="md-layout-item">
             <service-card v-if="services.length != 0" :services="services" ref="childServiceComponent" @data="dataService"/>
          </div>
        </div>
        
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:green">Diperiksa</span>
          </label> -->
          <!-- <div class="md-layout-item">
            <validation-provider rules="diperiksa" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-select v-model="nota_jasa_bkl_diperiksa" required>
                <md-option v-for="option in options_sa_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.nota_jasa_bkl_diperiksa" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-input v-model="nota_jasa_bkl_diperiksa" disabled/>
            </md-field>
          </div>
        <!-- </div>
        <div class="md-layout"> -->
          <div class="md-layout-item">
            <validation-provider rules="mengetahui" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Mengetahui</label>
              <md-select v-model="nota_jasa_bkl_mengetahui" required>
                <md-option v-for="option in options_auto_manager_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.nota_jasa_bkl_mengetahui" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation()">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {extend , ValidationObserver} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import ServiceCard from "@/pages/Dashboard/Workshop/NotaJasaBkl/ComponentForm/ServiceCard.vue";

Vue.use(VueSweetalert2);

//config validation input form
extend('jasano', {
  ...required,
  message: 'Nota Jasa No. field is required'
});
extend('datetime', {
  ...required,
  message: 'Datetime field is required'
});
extend('pkbno', {
  ...required,
  message: 'PKB No. field is required'
});
extend('diperiksa', {
  ...required,
  message: 'Diperiksa field is required'
});
extend('mengetahui', {
  ...required,
  message: 'mengetahui field is required'
});

export default {
  name: "add-nota-jasa-bkl",
  
  props: {
    data_id: Object
  },

  components: {ValidationError , ValidationObserver, "service-card": ServiceCard},

  mixins: [formMixin],

  data: () => ({
    // nota_jasa_bkl_no: null,
    nota_jasa_bkl_datetime: new Date().toISOString().slice(0,10),
    nota_jasa_bkl_pkb_id: null,
    nota_jasa_bkl_pkb_no: null,
    nota_jasa_bkl_mengetahui: null,
    nota_jasa_bkl_diperiksa: null,
    nota_jasa_bkl_total: null,
    options_sa_list: null,
    options_auto_manager_list: null,
    services:[],
  }),
    
  created() {
    this.getData();
    // if(this.data_id){
    //   this.services.nota_jasa_bkl_pkb_id = this.data_id.id
    //   }
  },
  
  methods: {
    //ambil data" yang diperlukan
    async getData(){
    

      this.getId()
      //ambil data pkb 
      await this.$store.dispatch("workshop_pkb/get",this.data_id.id)
      var pkb = await this.$store.getters["workshop_pkb/pkb"]
      this.services = pkb.pkb_service
      this.nota_jasa_bkl_pkb_no = pkb.pkb_no
      this.nota_jasa_bkl_pkb_id = pkb.id
      this.nota_jasa_bkl_diperiksa = pkb.pkb_service_estimate.sa_name.name

        //ambil list user sa
      //   var query = {"filter":{role:'service_advisor',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
      // await this.$store.dispatch("users/list",query) 
      // this.options_sa_list = await this.$store.getters["users/list"]


        //ambil list user auto manager
        var query = {"filter":{role:'workshop_head',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
        await this.$store.dispatch("users/list",query)
      this.options_auto_manager_list = await this.$store.getters["users/list"]
      
        
    }, 

    //confirmasi add
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      //check validasi input form
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addNotaJasaBkl()
        }
      });
    },
    
    //kirim data add ke api
    async addNotaJasaBkl() {
       
      //ambil data di child/fungsi getData di coponent form service card
      this.$refs.childServiceComponent.getData()

      const data = {
        type: "workshop_nota_jasa_bkls",
        // nota_jasa_bkl_no: this.nota_jasa_bkl_no,
        nota_jasa_bkl_datetime: this.nota_jasa_bkl_datetime,
        nota_jasa_bkl_pkb_id: this.nota_jasa_bkl_pkb_id,
        nota_jasa_bkl_total: this.nota_jasa_bkl_total,
        nota_jasa_bkl_mengetahui: this.nota_jasa_bkl_mengetahui,
        // nota_jasa_bkl_diperiksa: this.nota_jasa_bkl_diperiksa
      }
      
      try {
        //kirim data
        await this.$store.dispatch("workshop_nota_jasa_bkl/add", data);
        //panggi alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        //kembali ke list
        // await this.$router.replace({name: 'List Nota Jasa Bkl'});
        this.$parent.$parent.modalCloseCreateNotaJasa();
      } catch (e) {
        //panggil error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

    },
      
    //ambil pkb id dari url query 
    getId(){
      if(this.$route.name == "Add Nota Jasa Bkl" && this.$route.query.pkb_id){
        this.nota_jasa_bkl_pkb_id = this.$route.query.pkb_id
      }
    },
    
    //set data dari child
    dataService (value) {
      this.nota_jasa_bkl_total = value
    },
  },
  
  mounted() {
  console.log('Component mounted.')
    this.getId()
  }
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
